<template>
  <div id="app">
    <TopBar></TopBar>
    <div class="clearfix"></div>
    <MainMenu></MainMenu>
    <router-view id="main" :key="$route.path"></router-view>
    <div id="footer"></div>
  </div>
</template>

<script>
  import MainMenu from '@/components/MainMenu.vue'
  import TopBar from '@/components/TopBar.vue'

  /* Import CSS */
  //require('@/resources/style.css')

  export default {
    components: {
      MainMenu,
      TopBar
    }
  }

</script>

<style>
</style>

